// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as OtpValidationApiModel$PorterinFeature from "../api-model/OtpValidationApiModel.mjs";

function apiModelToState(model) {
  return {
          auth_token: model.customer.auth_token,
          mobile: model.customer.mobile
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(OtpValidationApiModel$PorterinFeature.t_decode(json), "OtpValidationEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
